package one.healthium.base.utils

import kotlin.math.roundToInt

object BodyParamsUtils {
    fun bmi(weight: Float?, height: Float?): Int? {
        if (weight == null || height == null || height == 0f) return null

        val heightInMeters = height.toMeters()
        return (weight / heightInMeters.times(heightInMeters)).roundToInt()
    }
}